export default __webpack_public_path__ + "maps-examples-user-location-annotation-thumbnail-480-4057a1aedf662ff69e7553216ff2f190.png";